import axiosInstance from '../Api/axiosInstance';

// Create a new template
export const createTemplate = (templateData) =>
	axiosInstance.post('/templates', templateData);

// Fetch all templates for the logged-in user's company
export const getTemplates = () => axiosInstance.get('/templates');

// Get a specific template by ID
export const getTemplateById = (templateId) =>
	axiosInstance.get(`/templates/${templateId}`);

// Update an existing template by ID
export const updateTemplate = (templateId, templateData) =>
	axiosInstance.put(`/templates/${templateId}`, templateData);

// Delete a template by ID
export const deleteTemplate = (templateId) =>
	axiosInstance.delete(`/templates/${templateId}`);

// Fetch templates created by System Admins
export const getSystemAdminTemplates = () =>
	axiosInstance.get('/templates/system-admin-templates');

// Fetch purchased templates for the logged-in company
export const getPurchasedTemplates = () =>
	axiosInstance.get('/templates/purchased');

// Claim a premium template for free (Agency plan perk)
export const claimFreeTemplate = (templateId) =>
	axiosInstance.post(`/templates/${templateId}/claim-free`);

// Clone a company template
export const cloneTemplate = (templateId) =>
	axiosInstance.post(`/templates/${templateId}/clone`);

// Send a test email from the email builder (uses company sender)
export const sendTemplateTestEmail = (data) =>
	axiosInstance.post('/templates/test', data);
